import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "@phosphor-icons/react";
import { useApi } from "@/lib/api";

export default function Emails() {
  const api = useApi();
  const [i, setI] = useState(0);
  const { data, error, isLoading } = useQuery({ queryKey: ["admin-onboarding"], queryFn: () => api.get("/admin/onboarding-emails"), retry: false });
  if (isLoading) return <p className="text-sm text-[#A3A3A3]">Loading…</p>;
  if (error) return <p data-testid="emails-admin-only" className="text-sm text-[#A3A3A3]">This page is only available to admins.</p>;
  const e = data.emails[i];
  return (
    <div data-testid="emails-page">
      <p className="font-mono text-xs text-[#A3A3A3] flex items-center gap-2"><ShieldCheck className="text-[#00FF9D]" /> ADMIN · ONBOARDING SEQUENCE · LIVE</p>
      <h1 className="font-display text-3xl md:text-4xl font-semibold mt-1">Onboarding emails</h1>
      <p className="mt-3 text-sm text-[#A3A3A3]">Sent automatically to every new subscriber. Subscribers never see this page. <span data-testid="onboarding-sent-total" className="font-mono text-white">{data.sent_total}</span> sent so far.</p>
      <div className="mt-8 grid lg:grid-cols-12 gap-4">
        <div className="lg:col-span-4 space-y-2">
          {data.emails.map((m, idx) => (
            <button key={m.key} data-testid={`email-tab-${idx}`} onClick={() => setI(idx)}
              className={`w-full text-left rounded-xl border p-4 transition-colors ${idx === i ? "border-[#00FF9D]/60 bg-[#00FF9D]/[0.05]" : "border-[#2A2A2A] bg-[#121212] hover:border-[#3A3A3A]"}`}>
              <p className="font-mono text-[11px] text-[#00FF9D]">{m.when}</p>
              <p className="text-sm font-medium mt-1">{m.subject}</p>
            </button>
          ))}
        </div>
        <div data-testid="email-preview" className="lg:col-span-8 rounded-xl border border-[#2A2A2A] bg-[#F5F5F2] text-[#111] overflow-hidden">
          <div className="border-b border-black/10 px-6 py-4 text-sm bg-white">
            <p><span className="text-black/50">From:</span> CalibRunway</p>
            <p data-testid="email-subject" className="mt-1 font-semibold">{e.subject}</p>
          </div>
          <iframe title="Onboarding email" sandbox="" srcDoc={e.html} className="w-full h-[560px] bg-[#F5F5F2]" />
        </div>
      </div>
    </div>
  );
}
